import { authRoles } from 'app/auth';
import i18next from 'i18next';
import en from './i18n/en';
import hu from './i18n/hu';
import LabConnectionEditForm from './editform/LabConnectionEditForm';
import LabConnectionTable from './table/LabConnectionTable';

i18next.addResourceBundle('en', 'labConnection', en);
i18next.addResourceBundle('hu', 'labConnection', hu);

export default [
	{
		path: '/lab-connection/edit/:id',
		component: LabConnectionEditForm,
		auth: authRoles.labConnection
	},
	{
		path: '/lab-connection/:sessionNameParam?',
		component: LabConnectionTable,
		auth: authRoles.labConnection
	}
];
